var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "payments-processing" },
    [
      _c(
        "div",
        { staticClass: "payments-processing__content" },
        [
          _c("ProgressBar", {
            attrs: {
              stepCount: _vm.stepCount,
              currentStep: _vm.currentStep,
              complete: _vm.complete,
              headerTitle1: "Payment(s) are currently being posted.",
              headerTitle2:
                "Please wait to print checks once payment(s) have finished posting.",
              headerWarning: "Do not leave or reload page",
              inProgressTitle: _vm.inProgressTitle,
              inProgressSubtitle: "Vendor: " + _vm.vendorInfo
            },
            scopedSlots: _vm._u([
              {
                key: "image",
                fn: function() {
                  return [
                    _c("img", {
                      staticClass: "payments-processing__graphic",
                      attrs: {
                        src: require("@/assets/process-payments.gif"),
                        alt: "Post Payments Animation"
                      }
                    })
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _c("Modal", {
        attrs: { visible: _vm.printChecksVisible, title: "Print A/P Checks" },
        on: { close: _vm.onPrintBatchNumbersCancel },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [
                _vm.postError
                  ? _c("NotificationBlock", {
                      attrs: {
                        state: "negative",
                        iconClassName: "icon-warning",
                        title: "Failed To Post"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "notification-block__message"
                                  },
                                  _vm._l(_vm.failedBatchNumber, function(
                                    response
                                  ) {
                                    return _c(
                                      "ul",
                                      { key: response.VendorNumber },
                                      [
                                        _c(
                                          "li",
                                          {
                                            ref: "notificationMessage",
                                            refInFor: true,
                                            staticClass:
                                              "notification-block__text"
                                          },
                                          [
                                            _vm._v(
                                              " Vendor " +
                                                _vm._s(response.VendorNumber) +
                                                " - " +
                                                _vm._s(response.ErrorMessage) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3215769913
                      )
                    })
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "print-ap-checks-modal" },
                  [
                    _vm.postSuccess
                      ? _c(
                          "div",
                          {
                            ref: "postSuccessMessage",
                            staticClass: "print-ap-checks-modal__batch-text"
                          },
                          [
                            _vm._v(
                              " Successfully posted the following batches: "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._l(_vm.postedBatchNumber, function(response) {
                      return _c(
                        "ul",
                        {
                          key: response.VendorNumber,
                          staticClass: "print-ap-checks-modal__vendor-list"
                        },
                        [
                          _c(
                            "li",
                            {
                              staticClass: "print-ap-checks-modal__vendor-item"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "print-ap-checks-modal__vendor-item-name"
                                },
                                [
                                  _vm._v(
                                    " Vendor: " +
                                      _vm._s(response.VendorNumber) +
                                      " "
                                  )
                                ]
                              ),
                              _vm._l(response.Invoices, function(invoice) {
                                return _c("div", {
                                  key: invoice.BatchNumber,
                                  staticClass:
                                    "print-ap-checks-modal__vendor-item-posting",
                                  domProps: {
                                    innerHTML: _vm._s(invoice.HTMLString)
                                  }
                                })
                              })
                            ],
                            2
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "ButtonSet",
                  [
                    _vm.anyBatchToPrint
                      ? _c("ButtonClassic", {
                          attrs: {
                            variant: "primary",
                            labelText: "Print Batch Numbers"
                          },
                          on: { click: _vm.onPrintBatchNumbers }
                        })
                      : _vm._e(),
                    !_vm.anyCheckToPrint
                      ? _c("ButtonClassic", {
                          attrs: { variant: "text", labelText: "Close" },
                          on: { click: _vm.onPrintBatchNumbersCancel }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Modal", {
        attrs: {
          title: "Printing",
          variant: "confirmation",
          visible: _vm.printVisible,
          applyLabelText: "Print Checks"
        },
        on: {
          apply: _vm.onPrint,
          cancel: _vm.onPrintCancel,
          close: _vm.onPrintCancel
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [
                _c("div", { staticClass: "printing-modal" }, [
                  _vm.paymentMethodsEnabled
                    ? _c(
                        "div",
                        { staticClass: "printing-modal__text" },
                        [
                          _vm._v(
                            " The following check number(s) were applied: "
                          ),
                          _c("br"),
                          _vm._l(_vm.checksPrinted, function(checks, index) {
                            return _c("div", { key: index }, [
                              _c("span", [_vm._v(_vm._s(checks))])
                            ])
                          }),
                          _c("br"),
                          _vm._v(" Click Print Checks to begin Printing ")
                        ],
                        2
                      )
                    : _vm._e(),
                  !_vm.paymentMethodsEnabled
                    ? _c("p", { staticClass: "printing-modal__text" }, [
                        _vm._v(
                          " You have assigned check number(s): " +
                            _vm._s(_vm.checksPrinted) +
                            " "
                        )
                      ])
                    : _vm._e()
                ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("PageUnloadAlert")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }